import React from "react";
import GoogleMapReact from "google-map-react";

import { Vehicle } from "../../../../models";
import * as simpleMapStyle from "../../../Schedules/components/MapView/simpleStyle.json";

import "./VehiclesMap.scss";

const DEFAULT_CENTER = { lat: 40.40016, lng: -80.04932 };
const DEFAULT_ZOOM = 11;

interface VehicleMarkerProps {
  lat: number;
  lng: number;
  vehicle: Vehicle;
}

function VehicleMarker({ vehicle }: VehicleMarkerProps) {
  const [open, setOpen] = React.useState(false);
  const loc = vehicle.location;

  return (
    <div className={`vehicle-marker${loc?.stale ? " stale" : ""}`} data-testid="vehicle-marker">
      <div className="pin" data-testid="vehicle-marker-pin" onClick={() => setOpen((o) => !o)} />
      <div
        className="pin-label"
        data-testid="vehicle-marker-label"
        onClick={() => setOpen((o) => !o)}
      >
        {vehicle.label}
      </div>
      {open && (
        <div className="popup">
          <div className="popup-label">{vehicle.label}</div>
          <div className="popup-row">{loc?.address ?? "—"}</div>
          <div className="popup-row">
            {typeof loc?.speedMph === "number" ? `${Math.round(loc.speedMph)} mph` : "—"}
          </div>
          <div className="popup-row">{vehicle.stats?.engineState ?? "—"}</div>
        </div>
      )}
    </div>
  );
}

function isLocated(v: Vehicle): boolean {
  return (
    !!v.location?.available &&
    typeof v.location.latitude === "number" &&
    typeof v.location.longitude === "number"
  );
}

export function VehiclesMap({ vehicles }: { vehicles: Vehicle[] }) {
  const located = vehicles.filter(isLocated);

  // Auto-fit bounds to all located vehicles once the maps API is ready.
  const handleApiLoaded = ({ map, maps }: { map: any; maps: any }) => {
    if (!located.length || !maps) return;
    const bounds = new maps.LatLngBounds();
    located.forEach((v) => bounds.extend(new maps.LatLng(v.location!.latitude, v.location!.longitude)));
    map.fitBounds(bounds);
  };

  return (
    <div className="vehicles-map-component">
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCkRYkFYLEOcaEbwmSYJXaQ2jlIttKkl8M", version: "3.58.8" }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={handleApiLoaded}
        defaultCenter={DEFAULT_CENTER}
        defaultZoom={DEFAULT_ZOOM}
        options={{ styles: simpleMapStyle }}
      >
        {located.map((v) => (
          <VehicleMarker key={v.id} lat={v.location!.latitude as number} lng={v.location!.longitude as number} vehicle={v} />
        ))}
      </GoogleMapReact>
    </div>
  );
}
